// デザインシステム - STELLAリデザイン
export const designSystem = {
  // メインカラー
  colors: {
    // プライマリ（About セクション）
    primary: '#2AB8D8',
    primaryLight: '#4AC8E8',
    primaryDark: '#1A98B8',

    // 背景色
    darkBg: '#030C1E',
    lightBg: '#FFFFFF',

    // テキスト色
    darkText: '#030C1E',
    lightText: '#FFFFFF',
    grayText: '#636C70',

    // アクセントカラー
    accent: '#2AB8D8',
  },

  // グラデーション（必要に応じて使用）
  gradients: {
    primary: 'linear-gradient(135deg, #4B72F3 0%, #6B8FF7 100%)',
    primaryVertical: 'linear-gradient(180deg, #4B72F3 0%, #6B8FF7 100%)',
    primaryHorizontal: 'linear-gradient(90deg, #4B72F3 0%, #6B8FF7 100%)',
    primarySoft: 'linear-gradient(135deg, rgba(75, 114, 243, 0.8) 0%, rgba(107, 143, 247, 0.8) 100%)',
    primarySubtle: 'linear-gradient(135deg, rgba(75, 114, 243, 0.1) 0%, rgba(107, 143, 247, 0.1) 100%)',
    
    // テキスト用
    textPrimary: '#4B72F3',
    textSecondary: '#4B72F3',
  },

  // カラーパレット
  colorPalette: {
    // プライマリカラー
    primary: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#4B72F3',
      600: '#3A5BD9',
      700: '#2d4bbf',
      800: '#1e3a8a',
      900: '#1e40af',
    },
    
    // グレーカラー
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
  },

  // タイポグラフィ
  typography: {
    fontFamily: {
      // 英字フォント
      en: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
      // 日本語フォント
      ja: "'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Hiragino Sans', 'Hiragino Kaku Gothic ProN', 'Yu Gothic UI', Meiryo, sans-serif",
      // 混在時のフォールバック
      primary: "'Inter', 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
      secondary: "'Noto Sans JP', 'Inter', -apple-system, BlinkMacSystemFont, Arial, sans-serif",
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
      '7xl': '4.5rem',
      '8xl': '6rem',
      '9xl': '8rem',
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900,
    },
  },

  // スペーシング
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '5rem',
    '5xl': '6rem',
  },

  // シャドウ
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },

  // ブレークポイント
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
};

// ヘルパー関数
export const getGradient = (type = 'primary', direction = '135deg') => {
  return designSystem.gradients[type] || designSystem.gradients.primary;
};

export const getColor = (color, shade = 500) => {
  return designSystem.colorPalette[color]?.[shade] || designSystem.colors[color] || '#000';
};

export const getSpacing = (size) => {
  return designSystem.spacing[size] || '0';
};

export const getShadow = (size) => {
  return designSystem.shadows[size] || designSystem.shadows.base;
};
